
interface TabProps {
  tabs: string[];
  onTabChange?: (tab: string) => void;
  activeTab?: string;
  containerClass?: string;
  buttonClass?: string;
  activeButtonClass?: string;
  textClass?: string;
  activeTextClass?: string;
}

export default function Tabs({
  tabs,
  onTabChange,
  activeTab,
  containerClass = "flex flex-row text-nowrap gap-7 py-3 overflow-x-auto rounded-lg px-4  w-full sm:w-fit custom-scrollbar text-base font-semibold text-sm text-primary-500 bg-white",
  buttonClass = "px-6 py-2 rounded-lg transition-all",
  activeButtonClass = "bg-primary-500",
  textClass = "text-primary-500",
  activeTextClass = "text-white",
}: TabProps) {
  
  const handleTabClick = (tab: string) => {
    if (onTabChange) onTabChange(tab);
  };

  return (
    <div className={containerClass}>
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => handleTabClick(tab)}
          className={`${buttonClass} ${
            activeTab === tab ? activeButtonClass : ""
          }`}
        >
          <span
            className={`${activeTab === tab ? activeTextClass : textClass}`}
          >
            {tab}
          </span>
        </button>
      ))}
    </div>
  );
}
